import { Component } from '@angular/core';

// Imports Standalone
import { PageHeaderComponent } from '../page-header/page-header.component';
import { LogsFormComponent } from './pages/logs-form/logs-form.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.less'],
    imports: [
        PageHeaderComponent,
        LogsFormComponent,
        TranslateModule
    ]
})
export class LogsComponent {

}
